import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  ref: "modalContent",
  id: "ReviewUploadModal"
}
const _hoisted_2 = { class: "ReviewUploadHeaderBlock" }
const _hoisted_3 = { class: "ReviewUploadProgressIndicator" }
const _hoisted_4 = { class: "ReviewUploadContentBlock" }
const _hoisted_5 = { class: "ReviewUploadButtonWrapper" }
const _hoisted_6 = { class: "ReviewUploadButtonWrapper" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ReviewUploadModalQuestion = _resolveComponent("ReviewUploadModalQuestion")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[3] || (_cache[3] = _createElementVNode("h3", null, "Review upload", -1 /* CACHED */)),
      _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.modalReviewUploadState) + "/2 ", 1 /* TEXT */)
    ]),
    _createElementVNode("div", _hoisted_4, [
      (_ctx.isModalStepUploadScopeAndType)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _cache[4] || (_cache[4] = _createElementVNode("p", { class: "ReviewUploadTextBlock" }, " Thank you for your submission! Before you go, please help us better understand what you submitted. ", -1 /* CACHED */)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.firstBatchOfSurveyQuestions, (question) => {
              return (_openBlock(), _createBlock(_component_ReviewUploadModalQuestion, {
                key: question.questionId,
                question: question,
                answer: _ctx.retrieveAnswerOfQuestion(question.questionId),
                onQuestionAnswered: _ctx.storeQuestionAnswer
              }, null, 8 /* PROPS */, ["question", "answer", "onQuestionAnswered"]))
            }), 128 /* KEYED_FRAGMENT */)),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("button", {
                class: "DriverButton ReviewUploadButton",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.showUploadContentsScreen && _ctx.showUploadContentsScreen(...args)))
              }, " Next ")
            ])
          ], 64 /* STABLE_FRAGMENT */))
        : (_ctx.isModalStepUploadContents)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _cache[6] || (_cache[6] = _createElementVNode("div", { class: "WarningContainer" }, [
                _createElementVNode("i", { class: "lnr-info WarningIcon" }),
                _createElementVNode("div", { class: "WarningMessage" }, " Please confirm if you have uploaded all email addresses for each enrolment, including any additional emails. ")
              ], -1 /* CACHED */)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.secondBatchOfSurveyQuestions, (question) => {
                return (_openBlock(), _createBlock(_component_ReviewUploadModalQuestion, {
                  key: question.questionId,
                  question: question,
                  answer: _ctx.retrieveAnswerOfQuestion(question.questionId),
                  onQuestionAnswered: _ctx.storeQuestionAnswer
                }, null, 8 /* PROPS */, ["question", "answer", "onQuestionAnswered"]))
              }), 128 /* KEYED_FRAGMENT */)),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("button", {
                  class: "NavigationBackButton",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.showUploadScopeAndTypeScreen && _ctx.showUploadScopeAndTypeScreen(...args)))
                }, [...(_cache[5] || (_cache[5] = [
                  _createElementVNode("i", { class: "lnr-arrow-left NavigationBackButtonIcon" }, null, -1 /* CACHED */),
                  _createTextVNode(" Previous Question ", -1 /* CACHED */)
                ]))]),
                _createElementVNode("button", {
                  class: "DriverButton ReviewUploadButton",
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
                }, " Next ")
              ])
            ], 64 /* STABLE_FRAGMENT */))
          : _createCommentVNode("v-if", true)
    ])
  ], 512 /* NEED_PATCH */))
}